<template>
  <CModal :title="title" :color="color" :show.sync="showModal" size="xl" class="basic-modal-color">

    <!-- INFO DEL ENVÍO -->
    <CRow class="mb-2">
      <CCol md="12">
        <div class="history-header">

          <div class="history-left">
            <span><strong>Fecha:</strong> {{ batchInfo.date | date }}</span>
            <span><strong>Tipo:</strong> {{ getTypeLabel(batchInfo.type) }}</span>
            <span>
              <strong>Estado:</strong>
              <span :class="['wa-badge', 'wa-badge--' + batchInfo.status]">
                {{ getBatchStatusLabel(batchInfo.status) }}
              </span>
            </span>
          </div>

          <div class="history-right">

            <span class="wa-metric">
              <CIcon name="cil-clock" class="wa-icon wa-icon--pending" />
              {{ batchInfo.total_request }}
            </span>

            <span class="wa-metric">
              <CIcon name="cil-check" class="wa-icon wa-icon--sent" />
              {{ batchInfo.total_send }}
            </span>

            <span class="wa-metric wa-checks wa-checks--delivered">
              <CIcon name="cil-check" class="wa-icon" />
              <CIcon name="cil-check" class="wa-icon wa-icon--second" />
              {{ batchInfo.total_delivered }}
            </span>

            <span class="wa-metric wa-checks wa-checks--read">
              <CIcon name="cil-check" class="wa-icon" />
              <CIcon name="cil-check" class="wa-icon wa-icon--second" />
              {{ batchInfo.total_read }}
            </span>

            <span class="wa-metric">
              <CIcon name="cil-warning" class="wa-icon wa-icon--failed" />
              {{ batchInfo.total_failed }}
            </span>

            <span class="wa-metric wa-total">
              Total: {{ batchInfo.total }}
            </span>

          </div>

        </div>

      </CCol>
    </CRow>

    <!-- FILTROS Y ACCIONES -->
    <CRow class="mb-3">

      <CCol md="4">
        <label>Estado:</label>
        <CSelect :value.sync="statusFilter" :options="statusOptions" />

      </CCol>

      <CCol md="8" class="text-right d-flex justify-content-end align-items-end">

        <CButton color="success" size="sm" @click="$emit('download-excel-detail', batchId)">
          Exportar Excel
        </CButton>

      </CCol>

    </CRow>

    <!-- TABLA -->
    <CRow>
      <CCol md="12">

        <CDataTable :items="filteredItems" :fields="fields" hover striped border small fixed pagination
          :table-filter="{ label: 'Buscar: ', placeholder: '...' }">

          <template #position="{ index }">
            <td class="text-center">
              {{ index + 1 }}
            </td>
          </template>

          <template #name="{ item }">
            <td>{{ item.guest_name }}</td>
          </template>

          <template #phone="{ item }">
            <td class="text-center">{{ formatContact(item.phone) }}</td>
          </template>

          <template #status="{ item }">
            <td class="text-center wa-cell">

              <!-- SOLICITADO -->
              <template v-if="item.status === 'request'">
                <CIcon name="cil-clock" class="wa-icon wa-icon--pending mr-1" />
                No enviado
              </template>

              <!-- ENVIADO (1 paloma gris) -->
              <template v-else-if="item.status === 'send' || item.status === 'sent'">
                <CIcon name="cil-check" class="wa-icon wa-icon--sent mr-1" />
                Enviado
              </template>

              <!-- ENTREGADO (2 palomas grises) -->
              <template v-else-if="item.status === 'delivered'">
                <span class="wa-checks wa-checks--delivered mr-1">
                  <CIcon name="cil-check" class="wa-icon" />
                  <CIcon name="cil-check" class="wa-icon wa-icon--second" />
                </span>
                Entregado
              </template>

              <!-- LEÍDO (2 palomas azules) -->
              <template v-else-if="item.status === 'read'">
                <span class="wa-checks wa-checks--read mr-1">
                  <CIcon name="cil-check" class="wa-icon" />
                  <CIcon name="cil-check" class="wa-icon wa-icon--second" />
                </span>
                Leído
              </template>

              <!-- ERROR -->
              <template v-else-if="item.status === 'failed'">
                <span class="wa-failed-status" v-c-tooltip.hover="getFailedStatusTooltip(item)">
                  <CIcon name="cil-warning" class="wa-icon wa-icon--failed mr-1" />
                  Error
                </span>
              </template>

              <!-- ERROR -->
              <template v-else-if="item.status === 'pending'">
                <CIcon name="cil-time" class="wa-icon wa-icon--pending mr-1" />
                Pendiente
              </template>

              <!-- DEFAULT -->
              <template v-else>
                {{ item.status }}
              </template>

            </td>
          </template>
          <template #updated_at="{ item }">
            <td class="text-center">
              {{ item.updated_at_human }}
            </td>
          </template>

          <template #metadata="{ item }">
            <td>
              <div v-if="item.failed_message">{{ item.failed_message }}</div>
              <div v-if="item.wamid" class="text-muted">WAMID: {{ item.wamid }}</div>
              <div v-if="!item.failed_message && !item.wamid" class="text-muted">-</div>
            </td>
          </template>
        </CDataTable>

      </CCol>
    </CRow>

    <!-- FOOTER -->
    <template #footer>
      <CButton @click="closeModal" color="secondary">
        Cerrar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import store from '@/store'
import ws_history from '@/services/events_whatsapp_history'

export default {
  name: 'HistoryDetailModal',
  components: {},
  data() {

    return {
      showModal: false,
      title: "Detalle del Envío",
      color: "info",

      batchId: null,
      batchInfo: {},
      items: [],
      event_id: this.$route.params.id,

      statusFilter: '',
      statusOptions: [
        { label: 'Todos', value: '' },
        { label: 'No enviado', value: 'request' },
        { label: 'Enviado', value: 'send' },
        { label: 'Entregado', value: 'delivered' },
        { label: 'Leído', value: 'read' },
        { label: 'Error', value: 'failed' }
      ]
    }
  },

  computed: {

    fields() {
      return [
        { key: 'position', label: 'N°', _style: 'width: 50px;' },
        { key: 'name', label: 'Invitado' },
        { key: 'phone', label: 'Contacto', _style: 'width: 120px;' },
        { key: 'status', label: 'Estado', _style: 'width: 120px;' },
        { key: 'updated_at', label: 'Última actualización', _style: 'width: 150px;' }
      ]
    },
    filteredItems() {
      const normalizedItems = this.items.map(i => ({
        ...i,
        // CDataTable table-filter uses field keys, so expose name for searching.
        name: i.guest_name || ''
      }))

      if (!this.statusFilter) return normalizedItems

      return normalizedItems.filter(i =>
        (i.status || '').toLowerCase().trim() === this.statusFilter
      )
    },
    hasErrors() {
      return this.items.some(i => {
        const s = (i.status || '').toLowerCase()
        return s === 'error' || s === 'failed'
      })
    }

  },

  methods: {
    async showDetail(item) {
      this.loading()

      this.batchId = item.id
      this.batchInfo = item
      this.showModal = true
      this.title = `Detalle del Envío - ${item.code.substr(-8)}`

      const response = await ws_history.getBatchDetail(this.event_id, this.batchId)

      if (response.type === "success") {
        this.items = response.data
      }

      this.loaded()
    },

    closeModal() {
      this.showModal = false
      this.items = []
      this.statusFilter = ''
      this.batchId = null
    },
    getTypeLabel(type) {
      switch (type) {
        case 'save_the_date': return 'Save The Date'
        case 'preinvitation': return 'Preinvitacion'
        case 'event_reminder': return 'Recordatorio de Evento'
        case 'reminder': return 'Recordatorio'
        case 'message': return 'Mensaje'
        case 'table': return 'Mesas'
        case 'tickets': return 'Tickets'
        case 'invitation': return 'Invitación'
        default: return type
      }
    },
    getBatchStatusLabel(status) {
      switch (status) {
        case 'pending': return 'Pendiente'
        case 'in_progress': return 'En proceso'
        case 'done': return 'Finalizado'
        default: return status
      }
    },
    getFailedStatusTooltip(item) {
      const message = (item && item.failed_message ? item.failed_message : '').trim()
      return message || 'No se recibio detalle del error.'
    },
    formatContact(value) {
      const raw = String(value || '').trim()
      if (!raw) return '-'

      if (raw.includes('@')) {
        return raw
      }

      const digits = raw.replace(/\D/g, '')
      if (!digits) {
        return raw
      }

      if (digits.length === 13 && digits.startsWith('521')) {
        return digits.slice(-10)
      }

      if (digits.length === 12 && digits.startsWith('52')) {
        return digits.slice(-10)
      }

      return digits
    },


    showToast(type, message) { store.commit('toast', { color: type, message }) },
    loading() { store.commit('loading') },

    loaded() { store.commit('loaded') }

  }
}
</script>

<style>
.basic-modal-color .modal-header {
  background-color: #668269 !important;
}

/* celdas */
.wa-cell {
  white-space: nowrap;
}

/* tamaño base iconos */
.wa-icon {
  font-size: 14px;
  vertical-align: -2px;
}

/* colores "tipo WhatsApp" (no dependen del tema) */
.wa-icon--pending {
  color: #6c757d;
}

/* gris */
.wa-icon--sent {
  color: #6c757d;
}

/* gris */
.wa-icon--failed {
  color: #dc3545;
}

/* rojo */

/* doble check: alineación/solape ligero */
.wa-checks {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.wa-icon--second {
  margin-left: -6px;
  /* solape tipo WhatsApp */
}

/* delivered: gris */
.wa-checks--delivered .wa-icon {
  color: #6c757d;
}

/* read: azul WhatsApp */
.wa-checks--read .wa-icon {
  color: #34B7F1;
}


/* ===== BADGE BASE ===== */
.wa-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  display: inline-block;
}


/* ===== ESTADOS ===== */

.wa-badge--pending {
  background-color: #f0ad4e;
  /* naranja */
}

.wa-badge--in_progress {
  background-color: #5bc0de;
  /* azul claro */
}

.wa-badge--done {
  background-color: #5cb85c;
  /* verde */
}

/* fallback */
.wa-badge--undefined,
.wa-badge--null {
  background-color: #6c757d;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
}

.history-left {
  display: flex;
  gap: 20px;
  align-items: center;
  font-size: 13px;
}

.history-right {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 13px;
}

.wa-metric {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.wa-total {
  font-weight: 600;
}
</style>
